import { Controller } from "@hotwired/stimulus"
import { pluralize } from "../lib/helpers"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static values = {
    count: Number,
    singular: String,
    plural: String,
  }

  connect() {
    reactor(this)
  }

  description() {
    return pluralize(this.countValue, `{{n}} ${this.singularValue}`, `{{n}} ${this.pluralValue}`)
  }
}
